import script from "./AppDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AppDashboard.vue?vue&type=style&index=0&id=dbf6453e&lang=scss"

const __exports__ = script;

export default __exports__